import Vue from 'vue'

import OMButton from './OMButton.vue'
import OMInput from './OMInput.vue'
import OMTablePagination from './OMTablePagination.vue'
import OMSelect from './OMSelect.vue'
import OMAccordion from './OMAccordion.vue'
import OMAutoComplete from './OMAutoComplete.vue'
import OMDatepicker from './OMDatepicker.vue'

Vue.component('OMButton', OMButton)
Vue.component('OMInput', OMInput)
Vue.component('OMTablePagination', OMTablePagination)
Vue.component('OMSelect', OMSelect)
Vue.component('OMAccordion', OMAccordion)
Vue.component('OMAutoComplete', OMAutoComplete)
Vue.component('OMDatepicker', OMDatepicker)
